"use client";

import type { PhoneClickPlacement } from "@homeinstead/analytics";
import type { ComponentProps } from "react";

import { trackPhoneClick } from "@homeinstead/analytics";
import { Link } from "~care/components/ui/Link/Link";

type PhoneLinkProps = Omit<ComponentProps<typeof Link>, "href"> & {
  phoneNumber: string;
  /**
   * Placement context attached to the phone-click analytics event so call
   * leads can be attributed to a specific surface.
   */
  placement: PhoneClickPlacement;
};

const PhoneLink = ({
  className,
  variant = "primary",
  children,
  phoneNumber,
  placement,
  ...props
}: PhoneLinkProps) => {
  return (
    <Link
      className={className}
      href={`tel:${phoneNumber}`}
      onClick={() => trackPhoneClick({ placement })}
      variant={variant}
      {...props}
    >
      {children ? children : phoneNumber}
    </Link>
  );
};

export default PhoneLink;
